import { render } from "./RepairDetect.vue?vue&type=template&id=023bb6a6&scoped=true"
import script from "./RepairDetect.vue?vue&type=script&lang=js"
export * from "./RepairDetect.vue?vue&type=script&lang=js"

import "./RepairDetect.vue?vue&type=style&index=0&id=023bb6a6&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023bb6a6"]])

export default __exports__